var render = function render(){var _vm=this,_c=_vm._self._c;return _c('section',{staticClass:"pacienti-page wh100"},[_c('router-view'),(_vm.$router.currentRoute.params.id)?_c('right-side-menu'):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }